/* ============================================================
   Mybibblio — "See inside" flip-through book preview
   • Opens a framed modal to flick through the sample pages
   • Shows the page set matching the SELECTED art-style variant
     (Pixar / Modern Flat) and updates live when it changes
   ============================================================ */
(function () {
  var CAPTIONS = ['Cover', 'Title page', 'Scene one', 'Scene two', 'Back cover'];

  function setup(flip) {
    if (!flip || flip.dataset.kbFlipInit === '1') return;
    flip.dataset.kbFlipInit = '1';

    // Buttons that open THIS viewer. A viewer with an id is addressed
    // explicitly (data-kb-see-target="#id") so more than one viewer can live
    // on a page; the product-page viewer has no id and keeps the old
    // behaviour of binding every untargeted button.
    var flipId = flip.getAttribute('id');
    var openBtns = flipId
      ? document.querySelectorAll('[data-kb-see-open][data-kb-see-target="#' + flipId + '"]')
      : document.querySelectorAll('[data-kb-see-open]:not([data-kb-see-target])');
    var sets = Array.prototype.slice.call(flip.querySelectorAll('[data-kb-flip-set]'));
    var prevBtn = flip.querySelector('[data-kb-flip-prev]');
    var nextBtn = flip.querySelector('[data-kb-flip-next]');
    var captionEl = flip.querySelector('[data-kb-flip-caption]');
    var countEl = flip.querySelector('[data-kb-flip-count]');
    var styleEl = flip.querySelector('[data-kb-flip-style]');
    var dotsEl = flip.querySelector('[data-kb-flip-dots]');
    var closeEls = flip.querySelectorAll('[data-kb-flip-close]');
    if (!sets.length) return;

    var style = 'pixar';
    var index = 0;
    var open = false;
    var preloaded = {};
    // When a button pins a specific art style (homepage previews), the
    // variant-picker sync below must not override it.
    var forcedStyle = null;
    // Single-page mode: the "Preview the dedication page" button opens ONE
    // page only (the title/dedication page) with no way to page into the story.
    var singleMode = false;
    var singleCaption = null;

    // Warm the browser cache for a style's pages so the viewer opens instantly.
    function preloadStyle(s) {
      if (!s || preloaded[s]) return;
      preloaded[s] = true;
      for (var i = 0; i < sets.length; i++) {
        if (sets[i].getAttribute('data-style') !== s) continue;
        var imgs = sets[i].querySelectorAll('img');
        for (var j = 0; j < imgs.length; j++) {
          var u = imgs[j].getAttribute('src');
          if (u) { var im = new Image(); im.src = u; }
        }
      }
    }

    // Which art style is selected in the variant picker? (value contains Pixar / Flat)
    function selectedStyle() {
      var picker = document.querySelector('.variant-picker') || document;
      var checked = picker.querySelectorAll('input[type="radio"]:checked, option:checked');
      for (var i = 0; i < checked.length; i++) {
        var v = (checked[i].value || checked[i].textContent || '').toLowerCase();
        if (v.indexOf('pixar') !== -1) return 'pixar';
        if (v.indexOf('flat') !== -1) return 'flat';
      }
      return null;
    }

    function activeSet() {
      for (var i = 0; i < sets.length; i++) {
        if (sets[i].getAttribute('data-style') === style) return sets[i];
      }
      return sets[0];
    }

    function pages() {
      return activeSet().querySelectorAll('.kb-flip__page');
    }

    function buildDots(total) {
      if (!dotsEl) return;
      dotsEl.innerHTML = '';
      for (var i = 0; i < total; i++) {
        var d = document.createElement('button');
        d.type = 'button';
        d.className = 'kb-flip__dot';
        d.setAttribute('aria-label', 'Go to page ' + (i + 1));
        (function (n) { d.addEventListener('click', function () { var p = index; index = n; render(p); }); })(i);
        dotsEl.appendChild(d);
      }
    }

    var flipTimer = null;
    function render(prevIdx) {
      // Show only the active style set
      for (var i = 0; i < sets.length; i++) {
        var on = sets[i].getAttribute('data-style') === style;
        sets[i].hidden = !on;
      }
      var pgs = pages();
      var total = pgs.length;
      if (index < 0) index = 0;
      if (index > total - 1) index = total - 1;

      // clear any in-flight page-turn classes
      if (flipTimer) { clearTimeout(flipTimer); flipTimer = null; }
      for (var j = 0; j < total; j++) {
        pgs[j].classList.remove('is-exit-f', 'is-exit-b', 'is-enter-f', 'is-enter-b');
        pgs[j].classList.toggle('is-current', j === index);
      }

      // 3D page-turn between two pages of the same set
      if (typeof prevIdx === 'number' && prevIdx >= 0 && prevIdx < total && prevIdx !== index) {
        var dir = index > prevIdx ? 'f' : 'b';
        var oldPg = pgs[prevIdx], newPg = pgs[index];
        void newPg.offsetWidth; // restart animations
        oldPg.classList.add('is-exit-' + dir);
        newPg.classList.add('is-enter-' + dir);
        flipTimer = setTimeout(function () {
          oldPg.classList.remove('is-exit-' + dir);
          newPg.classList.remove('is-enter-' + dir);
          flipTimer = null;
        }, 460);
      }

      // a page may carry its own caption (viewers with a different page run)
      var curPg = pgs[index];
      var ownCap = curPg ? curPg.getAttribute('data-caption') : null;
      if (captionEl) captionEl.textContent = singleCaption || ownCap || CAPTIONS[index] || '';
      if (countEl) countEl.textContent = singleMode ? '' : (index + 1) + ' / ' + total;
      if (styleEl) styleEl.textContent = activeSet().getAttribute('data-style-label') || '';

      if (dotsEl && singleMode) dotsEl.innerHTML = '';
      if (dotsEl && !singleMode) {
        if (dotsEl.children.length !== total) buildDots(total);
        for (var k = 0; k < dotsEl.children.length; k++) {
          dotsEl.children[k].classList.toggle('is-active', k === index);
        }
      }
      if (prevBtn) prevBtn.disabled = singleMode || index === 0;
      if (nextBtn) nextBtn.disabled = singleMode || index === total - 1;
    }

    function go(delta) {
      if (singleMode) return;                 // one page only
      var p = index; index += delta; render(p);
    }

    function show(startIndex, pinStyle, single, captionOverride) {
      forcedStyle = pinStyle || null;
      singleMode = !!single;
      singleCaption = captionOverride || null;
      flip.classList.toggle('kb-flip--single', singleMode);
      var sel = forcedStyle || selectedStyle();
      if (sel) style = sel;
      preloadStyle(style);
      var total = pages().length;
      index = (typeof startIndex === 'number' && startIndex >= 0 && startIndex < total) ? startIndex : 0;
      flip.hidden = false;
      flip.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      open = true;
      // Paint the correct style/page BEFORE the dialog animates in, otherwise
      // reopening with a different art style flashes the previous one.
      render();
      // rAF so the enter transition plays
      requestAnimationFrame(function () { flip.classList.add('is-open'); });
    }
    function hide() {
      flip.classList.remove('is-open');
      open = false;
      flip.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      setTimeout(function () { if (!open) flip.hidden = true; }, 220);
    }

    Array.prototype.forEach.call(openBtns, function (b) {
      b.addEventListener('click', function (e) {
        e.preventDefault();
        var pg = parseInt(b.getAttribute('data-kb-see-page') || '0', 10);
        show(
          isNaN(pg) ? 0 : pg,
          b.getAttribute('data-kb-see-style'),
          b.hasAttribute('data-kb-see-only'),
          b.getAttribute('data-kb-see-caption')
        );
      });
    });
    Array.prototype.forEach.call(closeEls, function (c) {
      c.addEventListener('click', function (e) { e.preventDefault(); hide(); });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { go(-1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(1); });

    document.addEventListener('keydown', function (e) {
      if (!open) return;
      if (e.key === 'Escape') hide();
      else if (e.key === 'ArrowLeft') go(-1);
      else if (e.key === 'ArrowRight') go(1);
    });

    // Touch swipe
    var x0 = null;
    var book = flip.querySelector('[data-kb-flip-book]');
    if (book) {
      book.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
      book.addEventListener('touchend', function (e) {
        if (x0 === null) return;
        var dx = e.changedTouches[0].clientX - x0;
        if (Math.abs(dx) > 45) go(dx < 0 ? 1 : -1);
        x0 = null;
      }, { passive: true });
    }

    // Keep the preview in sync with the art-style selection
    document.addEventListener('change', function (e) {
      if (forcedStyle) return; // style pinned by the opening button
      var t = e.target;
      if (!t || t.type !== 'radio') return;
      var v = (t.value || '').toLowerCase();
      if (v.indexOf('pixar') === -1 && v.indexOf('flat') === -1) return;
      var sel = selectedStyle();
      if (sel) preloadStyle(sel);
      if (sel && sel !== style) { style = sel; if (open) render(); }
    });

    // Preload the selected style's pages as soon as the button nears the viewport,
    // so tapping it opens the viewer instantly (esp. on mobile).
    if ('IntersectionObserver' in window && openBtns.length) {
      var io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) { preloadStyle(selectedStyle() || 'pixar'); io.disconnect(); break; }
        }
      }, { rootMargin: '300px' });
      Array.prototype.forEach.call(openBtns, function (b) { io.observe(b); });
    }
  }

  function start() {
    document.querySelectorAll('[data-kb-flip]').forEach(setup);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
